import { useConsignees } from '../hooks/useConsignees'
import { Chip } from './ui'

/**
 * Small pill showing the consignee's name (e.g. "Mom") next to a sale.
 * Returns null when the sale was not made by a consignee.
 */
export default function ConsigneeBadge({ consigneeId }: { consigneeId: string | null }) {
  const { data: consignees } = useConsignees()
  if (!consigneeId) return null
  const consignee = (consignees ?? []).find((c) => c.id === consigneeId)
  if (!consignee) return null
  return <Chip tone="accent">{consignee.name}</Chip>
}
